import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validatePhoneNumber(): ValidatorFn {
    return (control: AbstractControl): Record<string, unknown> | null => {
        const reg = new RegExp('(^|W)(\\(?(\\+|00)?48\\)?)?[ -]?\\d{3}[ -]?\\d{3}[ -]?\\d{3}(?!\\w)');
        const isNumber = reg.test(control?.value);

        if (!isNumber) {
            if (control.value === '') {
                return null;
            }

            return {
                phoneNumberError: { value: 'value is not a phone number' },
                req: { value: true },
            };
        }
        return null;
    };
}
